var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.498 1.08008L18.6559 5.79002V15.2099L10.498 19.9198L2.34015 15.2099V5.79002L10.498 1.08008Z",
    fill: "#FAE232",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M10.4972 3.23242L16.7904 6.8658V14.1326L10.4972 17.7659L4.20403 14.1326V6.8658L10.4972 3.23242Z",
    fill: "#FAE232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.497 2.42139L10.9216 0.357166L10.5043 0.116211L10.0869 0.357166L1.92906 5.0671L1.51172 5.30806V5.78996V15.2098V15.6917L1.92906 15.9327L5.50441 17.9969L5.92176 17.2741L2.34641 15.2098V5.78996L10.5043 1.08003L14.0796 3.14426L14.497 2.42139ZM6.85756 17.8144L10.5043 19.9198L18.6621 15.2098V5.78996L15.0154 3.68454L15.4328 2.96168L19.0795 5.0671L19.4968 5.30806V5.78996V15.2098V15.6917L19.0795 15.9327L10.9216 20.6426L10.5043 20.8836L10.0869 20.6426L6.44022 18.5372L6.85756 17.8144Z",
    fill: "#FAE232"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.917 11.1803L11.537 9.61435V9.11035L11.024 8.59735H9.773L9.296 9.07435V9.53335H8.27V8.75935L9.323 7.70635H11.474L12.563 8.79535V9.91135L10.925 11.4953V12.3773H9.917V11.1803ZM9.818 13.6643V13.1873L10.16 12.8453H10.682L11.024 13.1873V13.6643L10.682 14.0063H10.16L9.818 13.6643Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.8bcf25369ce967985e070b7b8104cec3.svg";
export { ForwardRef as ReactComponent };